/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * To the extend possible, prefer nodes with specified characteristics when placing application instances.
 *
 */
export enum ApplicationAffinityHardwareGeneration {
	HIGHEST_OVERALL_PERFORMANCE = "highest-overall-performance",
}
